"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSeoTitle = exports.seoTitlePropertyDefinition = void 0;
exports.seoTitlePropertyDefinition = {
    view: {
        label: 'SEO title',
        hint: 'Blue text on Google searches (and on browser tabs); important ranking factor, so write it like a user searches – \'Keyword: Click stimulus\' (The brand\' - Redbull.com\' is added automatically by Google); Learn more <a href=\'http://bit.ly/2wfLt8d\' target=\'_blank\'>here</a>.',
    },
    constraints: [
        {
            name: 'maxLength',
            argument: 60,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'seo-title',
};
const isSeoTitle = (prop) => {
    return prop.name === exports.seoTitlePropertyDefinition.name;
};
exports.isSeoTitle = isSeoTitle;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VvLXRpdGxlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvc2VvLXRpdGxlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMEJBQTBCLEdBQUc7SUFDeEMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLFdBQVc7UUFDbEIsSUFBSSxFQUFFLHVSQUF1UjtLQUM5UjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLEVBQUU7U0FDYjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxXQUFXO0NBQ2MsQ0FBQTtBQUkxQixNQUFNLFVBQVUsR0FBRyxDQUFDLElBQWtCLEVBQW9CLEVBQUU7SUFDakUsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLGtDQUEwQixDQUFDLElBQUksQ0FBQTtBQUN0RCxDQUFDLENBQUE7QUFGWSxRQUFBLFVBQVUsY0FFdEIifQ==